import { Responsive, WidthProvider } from 'react-grid-layout';

const ReactGridLayout = WidthProvider(Responsive);
export default ReactGridLayout;
